import Vue from "vue";
import VueI18n from "vue-i18n";
import moment from "moment-timezone";
import "moment/locale/fr";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";

Vue.use(VueI18n);

export const SUPPORTED_LOCALES = [
  { code: "en", labelKey: "language.english" },
  { code: "fr", labelKey: "language.french" },
  { code: "es", labelKey: "language.spanish" },
];

const STORAGE_KEY = "appLocale";

function getSavedLocale() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && SUPPORTED_LOCALES.some((l) => l.code === saved)) return saved;
  return "en";
}

const i18n = new VueI18n({
  locale: getSavedLocale(),
  fallbackLocale: "en",
  messages: { en, fr, es },
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});

export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.some((l) => l.code === locale)) return;
  i18n.locale = locale;
  moment.locale(locale);
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.setAttribute("lang", locale);
}

moment.locale(i18n.locale);
document.documentElement.setAttribute("lang", i18n.locale);

export default i18n;
